import {
  COMPANY_LOCATION_TAB_PATH,
  DEFAULT_LOCATION_SETTINGS_TAB,
  LOCATION_SETTINGS_TABS,
  LocationSettingsTab,
} from '../constants/location-settings.constants';

export function parseLocationSettingsTab(raw: string | null | undefined): LocationSettingsTab {
  const match = LOCATION_SETTINGS_TABS.find(tab => tab.id === raw);
  return match ? match.id : DEFAULT_LOCATION_SETTINGS_TAB;
}

/** Query params of the Location tab; the default tab is left out of the URL. */
export function buildLocationSettingsQueryParams(
  locationId: string,
  tab: LocationSettingsTab
): Record<string, string | null> {
  return {
    location: locationId || null,
    tab: tab === DEFAULT_LOCATION_SETTINGS_TAB ? null : tab,
  };
}

export interface LegacySettingsRedirect {
  commands: string[];
  queryParams: Record<string, string>;
}

/**
 * Where an old `/admin/settings?company=&location=&tab=` link now lands: the
 * company's Location tab with the same location and sub-tab, or the companies
 * list when no company was given.
 */
export function buildLegacySettingsRedirect(
  params: Record<string, unknown>
): LegacySettingsRedirect {
  const company = typeof params['company'] === 'string' ? params['company'].trim() : '';
  if (!company) {
    return { commands: ['/admin/companies'], queryParams: {} };
  }
  const queryParams: Record<string, string> = {};
  const location = typeof params['location'] === 'string' ? params['location'].trim() : '';
  if (location) {
    queryParams['location'] = location;
  }
  const tab = parseLocationSettingsTab(typeof params['tab'] === 'string' ? params['tab'] : null);
  if (tab !== DEFAULT_LOCATION_SETTINGS_TAB) {
    queryParams['tab'] = tab;
  }
  return {
    commands: ['/admin/companies', company, COMPANY_LOCATION_TAB_PATH],
    queryParams,
  };
}
